var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyFavorites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 130,
    viewBox: "0 0 187 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0338 38.1804C84.5337 15.6803 132.534 11.602 132.534 11.602",
    stroke: "#FF1E1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6557 37.2678L93.5486 37.2333C93.5835 36.5913 93.6012 35.9448 93.6012 35.2941C93.6012 15.8017 77.7276 0 58.1466 0C38.5656 0 22.6921 15.8017 22.6921 35.2941C22.6921 43.7366 25.6698 51.4868 30.6368 57.5606L93.3045 130L156.564 57.5619C161.532 51.4879 164.51 43.7372 164.51 35.2941C164.51 15.8017 148.637 0 129.056 0C109.475 0 93.6012 15.8017 93.6012 35.2941C93.6012 35.9564 93.6195 36.6145 93.6557 37.2678Z",
    fill: "#FF97B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.51 12.0018C174.18 11.9052 186.034 15.6283 186.034 22.6804C186.034 40.8806 85.5342 76.1804 15.5342 77.6804C-13.3539 78.2994 5.67521 62.3028 30.5103 57.5839",
    stroke: "#FF1E1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5103 104.775C115.9 120.619 233.406 87.9996 158.67 71.2239C154.754 70.3448 150.69 69.6077 146.514 69",
    stroke: "#FF1E1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFavorites);
export default __webpack_public_path__ + "static/media/empty_favorites.c110d084498cb19489c5fac0a05a6feb.svg";
export { ForwardRef as ReactComponent };